// extracted by mini-css-extract-plugin
module.exports = {"container":"AdminPage_container__2fGW6","loadingWrapper":"AdminPage_loadingWrapper__3qys9"};